import { PaymentRecord } from '../../lib/types/models/payment-record/payment-record'
import { PaymentRecordInput } from '../../lib/types/models/payment-record/payment-record-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createPaymentRecord(data: IdInput<PaymentRecordInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.enrollments.createPaymentRecord.url, { id }))
    .post<PaymentRecord, PaymentRecordInput>(rest)
}
